define( function() {
	return [];
} );



/*****************
 ** WEBPACK FOOTER
 ** ./~/jquery/src/var/arr.js
 ** module id = 420
 ** module chunks = 2
 **/